// extracted by mini-css-extract-plugin
export default {"wrap":"yK-z","fullWidth":"zK-z","hideOnDesktop":"AK-z","content":"BK-z","hasOpenedNav":"CK-z","crumbsList":"DK-z","dropdownsWrap":"EK-z"};